import React, {useEffect, useMemo, useState} from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  withStyles,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import styles from './styles';
import PropTypes from 'prop-types';
import { Portlet, PortletContent, TableCellWithConfig } from 'components';
import classNames from 'classnames';
import Columns from '../columns';
import TemplateGroup from '../components/TemplateGroup';
import { getTemplateGroupContent } from '../helper';

function TemplateComparisonTable(props) {
  const {
    classes,
    className,
    columnConfigs,
    t,
    templates,
    selectedTemplateIds,
    onSelectTemplate,
    idKey
  } = props;

  const rootClassName = classNames(classes.root, className);

  const filteredTemplates = useMemo(() => {
    return templates.filter(template => template.stops.length > 0);
  }, [templates]);
  function toggleExpanded(id) {
    setCollapsedTemplates((prevState) => {
      const newState = { ...prevState };
      newState[id] = !newState[id];
      return newState;
    });
  }

  // object that contains the expanded state of each template and unassigned
  const [collapsedTemplates, setCollapsedTemplates] = useState({});

  useEffect(() => {
    const result = filteredTemplates.reduce((acc, template) => {
      acc[template[idKey]] = true;
      return acc;
    }, {});
    setCollapsedTemplates(result);
  }, [filteredTemplates, idKey]);

  return (
    <div style={{ position: 'relative' }}>
      <Portlet className={rootClassName}>
        <PortletContent noPadding>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {columnConfigs.map((columnConfig) => (
                  <TableCellWithConfig
                    className={classes.tableHeader}
                    config={columnConfig}
                    key={columnConfig.order}
                    width={columnConfig.width}
                  >
                    {Columns[columnConfig.columnName].header({
                      t,
                    })}
                  </TableCellWithConfig>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTemplates.map((template) => (
                <TemplateGroup
                  key={template[idKey]}
                  isCollapsed={collapsedTemplates[template[idKey]]}
                  onSelectStop={() => {}}
                  onSelectGroup={() => onSelectTemplate(template)}
                  selectedStops={[]}
                  stops={template.stops}
                  toggleCollapsed={(e) => {
                    e.stopPropagation();
                    toggleExpanded(template[idKey]);
                  }}
                  columnConfigs={columnConfigs}
                  template={template}
                  templateSelected={selectedTemplateIds.includes(template[idKey])}
                  groupContent={getTemplateGroupContent(template)}
                  shouldStopsHover={false}
                />
              ))}
            </TableBody>
          </Table>
        </PortletContent>
      </Portlet>
    </div>
  );
}

TemplateComparisonTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  columnConfigs: PropTypes.array.isRequired,
  templates: PropTypes.array.isRequired,
  selectedTemplateIds: PropTypes.array.isRequired,
  onSelectTemplate: PropTypes.func.isRequired,
  idKey: PropTypes.string,
};

export default compose(
  withStyles(styles),
  withTranslation()
)(TemplateComparisonTable);
